var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicLargeBottom = function SvgOrganicLargeBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2263 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 2.994C66.996 68.359 88.05 232.75 284.78 374.6c245.913 177.313 1225.1 86.908 1650 73.423C2274.69 437.235 2261 147.195 2261 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2223 0H0c-.004 65.5 21.05 230.233 217.78 372.377 245.913 177.68 1225.1 87.088 1650 73.574C2207.69 435.14 2223 147.5 2223 0Z"
  })));
};
export default SvgOrganicLargeBottom;